import { render, staticRenderFns } from "./LocalVideo.vue?vue&type=template&id=ecea420c&scoped=true&"
import script from "./LocalVideo.vue?vue&type=script&lang=js&"
export * from "./LocalVideo.vue?vue&type=script&lang=js&"
import style0 from "./LocalVideo.vue?vue&type=style&index=0&id=ecea420c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecea420c",
  null
  
)

export default component.exports